import React, { useState } from 'react'
import {
    Box,
    Button,
    HStack,
    ModalBody,
    ModalHeader,
    Text
} from "@chakra-ui/react";
import { PaperPlaneRight } from "phosphor-react";

import { XCircle } from "phosphor-react";

import { COLORS } from "../../Helper/Colors";

import { Select } from '@chakra-ui/react'

import { MultiSelect } from './MultiSelect';


export const SendNotificationModal = ({ type, initialValues = "", onClose }) => {

    const [selectdType, setSelectedType] = useState("All");
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            width={"100%"}
            height={"100%"}
            overflow={"auto"}
            padding={4}
            paddingBottom={2}
        >
            <ModalHeader

                flex="1"
                width={"100%"}
                justifyContent={"space-between"}
                alignItems="center"
            >

                <HStack
                    display={"flex"}
                    flex="1"
                    alignItems="center"
                    fontWeight={"600"}
                    color={COLORS.brandDark}
                    justifyContent={"flex-end"}
                >

                    <XCircle
                        height="24"
                        width="24"
                        onClick={onClose}
                        cursor={"pointer"}
                        color={COLORS.lightGray}
                    />
                </HStack>
                <Box marginBottom={"4"}>

                    <Text>SEND NOTIFICATION</Text>

                </Box>
                <Box display={"flex"} flexDirection={"column"} marginBottom={"4"}>

                    <Box width={"50%"} paddingTop={"1"}>

                        {
                            <Select placeholder='send To All User' onChange={(e) => {
                                e.target.value == "custom" ? setSelectedType("custom") : setSelectedType("all")
                            }}>
                                <option value='custom'>custom</option>

                            </Select>
                        }

                    </Box>
                    {selectdType == "custom" ? <Box height={"300px"} marginTop={"10px"}>
                        <MultiSelect />
                    </Box> : ""}
                    <Button
                        backgroundColor={COLORS.brand}
                        color={"white"}
                        title="Send Notification"
                        _hover={{ backgroundColor: COLORS.brand }}
                        rightIcon={<PaperPlaneRight size={18} />}
                        isLoading={false}
                        marginTop={"5"}
                        width={"100px"}
                    >
                        Send
                    </Button>
                </Box>

            </ModalHeader>
            <ModalBody className='design-scrollbar' >
            </ModalBody>
        </Box>
    )
}
